import { render } from "./index.vue?vue&type=template&id=0033dbae&scoped=true?status=30"
import script from "./index.vue?vue&type=script&lang=js?status=30"
export * from "./index.vue?vue&type=script&lang=js?status=30"

import "./index.vue?vue&type=style&index=0&id=0033dbae&lang=less&scoped=true?status=30"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0033dbae"]])

export default __exports__